import { useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '../constants/index';

export const useInvalidateQueries = (...keys: QueryKey[]) => {
  const queryClient = useQueryClient();

  return {
    invalidateQuery: () => {
      for (const key of keys) {
        queryClient.invalidateQueries({ exact: false, queryKey: [key] });
      }
    },
  };
};
